import { useUser } from "src/shared/context/UserContext";

export const useLogoUrl = (): string => {
  const { user } = useUser();

  const organizationName = user?.orgName || "";
  return organizationName ? sessionStorage.getItem(`Logo${organizationName}`) || "" : "";
};

// utils/formatters.ts
export const roundValue = (value: number | string | undefined): string => {
  if (value === undefined) return "0.00";
  const num = typeof value === "string" ? parseFloat(value) : value;
  if (isNaN(num)) return "0.00";

  const thirdDecimal = Math.floor(num * 1000) % 10;
  return thirdDecimal >= 5 ? (Math.ceil(num * 100) / 100).toFixed(2) : num.toFixed(2);
};

